import { HttpInterceptorFn } from '@angular/common/http';
import {inject} from '@angular/core';
import {MemoryService} from '../services/memory.service';

export const accessTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const memoryService = inject(MemoryService);
  const accessToken = memoryService.accessToken;

  if (!accessToken) {
    return next(req);
  }

  const accessTokenRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  return next(accessTokenRequest);
};
